import { render, staticRenderFns } from "./package_history_loader.vue.js?vue&type=template&id=3358649c!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./package_history_loader.vue?vue&type=template&id=3358649c"
import script from "./package_history_loader.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./package_history_loader.vue?vue&type=script&lang=js"
export * from "./package_history_loader.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./package_history_loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports